var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Sound/Transparent - WithoutCircle",
    clipPath: "url(#clip0_577_171098)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sound"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M173.419 162.912C178.071 159.818 182.093 155.428 185.237 150.863C188.086 146.711 190.249 142.019 191.278 137.08C192.555 130.948 192.108 124.586 190.177 118.637C187.081 109.093 180.769 100.901 173.746 93.8704",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M156.824 154.679C160.336 152.34 163.36 149.048 165.73 145.596C170.621 138.478 172.106 129.706 169.44 121.442C167.126 114.284 162.41 108.137 157.144 102.864",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M140.214 146.343C142.672 144.704 144.778 142.414 146.43 139.988C149.766 135.097 150.763 129.052 148.936 123.398C147.356 118.49 144.132 114.291 140.533 110.68",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M68.6044 145.471H95.0335C96.2973 145.471 97.2942 145.836 98.1935 146.735L122.117 169.275C125.054 172.042 129.889 169.967 129.889 165.942V128.272V90.6016C129.889 86.5057 124.918 84.4617 122.021 87.3567L98.2174 111.137C97.3476 112.004 96.1746 112.489 94.9537 112.489H68.6044C66.0588 112.489 64 114.541 64 117.078V140.882C64 143.419 66.0588 145.471 68.6044 145.471Z",
    stroke: "white",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_577_171098"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSound);
export default __webpack_public_path__ + "static/media/Sound.954f30fd1e2027934b1988375f571a21.svg";
export { ForwardRef as ReactComponent };